import LocationIcon from '@atlaskit/icon/glyph/location';
import { dataResidencyInScopeEndUserDataV2, dataResidencyOutOfScopeEndUserData } from './TrustTransform';
import { dataResidencyInScopeEndUserDataForCustomer, dataResidencyOutOfScopeEndUserDataForCustomer } from './TrustTransform/trustTransformV2';
import { jsx as _jsx } from "react/jsx-runtime";
export const updatePrivacySecurityConfig = privacySecurityConfig => {
  var _updatedprivacySecuri;
  const updatedprivacySecurityConfig = privacySecurityConfig;
  const outOfScopeSection = {
    question: () => [{
      type: 'text',
      text: 'List of out-of-scope End-User Data'
    }],
    answer: dataResidencyOutOfScopeEndUserData,
    iconBefore: /*#__PURE__*/_jsx(LocationIcon, {
      label: ""
    })
  };
  const dataStorageAndManagementQnaArray = updatedprivacySecurityConfig === null || updatedprivacySecurityConfig === void 0 ? void 0 : (_updatedprivacySecuri = updatedprivacySecurityConfig[0]) === null || _updatedprivacySecuri === void 0 ? void 0 : _updatedprivacySecuri.qna;
  dataStorageAndManagementQnaArray[2].answer = dataResidencyInScopeEndUserDataV2; // adding the new function for in-scope data

  const outOfScopeAlreadyExists = dataStorageAndManagementQnaArray.some(entry => entry.answer === dataResidencyOutOfScopeEndUserData);
  if (!outOfScopeAlreadyExists) dataStorageAndManagementQnaArray.splice(3, 0, outOfScopeSection); // pushing after in-scope-eud section

  return updatedprivacySecurityConfig;
};
export const updatePrivacySecurityConfigForCustomerPage = privacySecurityConfig => {
  var _updatedprivacySecuri2;
  const updatedprivacySecurityConfig = privacySecurityConfig;
  const outOfScopeSection = {
    question: () => [{
      type: 'heading-with-bullet',
      text: 'List of out-of-scope End-User Data'
    }],
    answer: dataResidencyOutOfScopeEndUserDataForCustomer
  };
  const dataStorageAndManagementQnaArray = updatedprivacySecurityConfig === null || updatedprivacySecurityConfig === void 0 ? void 0 : (_updatedprivacySecuri2 = updatedprivacySecurityConfig[0]) === null || _updatedprivacySecuri2 === void 0 ? void 0 : _updatedprivacySecuri2.qna;
  dataStorageAndManagementQnaArray[2].answer = dataResidencyInScopeEndUserDataForCustomer; // adding the new function for in-scope data

  const outOfScopeAlreadyExists = dataStorageAndManagementQnaArray.some(entry => entry.answer === dataResidencyOutOfScopeEndUserDataForCustomer);
  if (!outOfScopeAlreadyExists) dataStorageAndManagementQnaArray.splice(3, 0, outOfScopeSection); // pushing after in-scope-eud section

  return updatedprivacySecurityConfig;
};